




























import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import { ChatStubState } from './BuilderChat.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDot
  },
   computed: {
    ...mapGetters('builder', { appType: 'getAppType' }),
  },
})
export default class BuilderChatPersonal extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ChatStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  @Ref('input') input!: HTMLInputElement

  appType!: string
  
  processing = false

  get title(): string {
    return this.value.channels[1]?.name ?? ''
  }

  set title(value: string) {
    this.$emit('input', {
      ...this.value,
      channels: this.value.channels.map((c, i) => (i === 1 ? { ...c, name: value } : c)),
    })
  }

  get isNextStepDisabled(): boolean {
    return !this.title
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }
    if (this.title.length > 30) {
      this.$toasted.error(String(this.$t('errors.chats.count')))
      return
    }
    this.processing = true
    
    try {

      let id = 0
      if(this.value.channels[1]) {
        id = this.value.channels[1].id
      }

      await this.$store.dispatch('builder/mutateChannel', {
        name: this.title,
        isPersonal: true,
        id
      })

      this.$emit('next')
    } catch (e: any) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async onStubStateReady(): Promise<void> {
    if (this.value.channels.length < 1) {
      this.$emit('back')
      return
    }

    if (!this.value.channels[1]) {
      this.$emit('input', {
        channels: [
          ...this.value.channels,
          {
            id: -Number(Date.now().toString()),
            name: this.$t('personalChat'),
            tariffs: [],
            image: null,
            highlight: 'chat',
          },
        ],
      })
    } else {
      this.$emit('input', {
        channels: this.value.channels.map((c, i) => (i === 1 ? { ...c, highlight: 'chat' } : c)),
      })
    }

    this.input.focus()
  }
}
